import * as React from "react";
import Home from "./views/Home";
import "./App.scss";

const App: React.FC = () => {
  return <Home />;
};

export default App;
